import { render, staticRenderFns } from "./JournalHome.vue?vue&type=template&id=aa04a894&scoped=true"
import script from "./JournalHome.vue?vue&type=script&lang=js"
export * from "./JournalHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa04a894",
  null
  
)

export default component.exports